(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kopreness-reviews"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('kopreness-reviews')) {
  customElements.define('kopreness-reviews', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
    }
    initialize() {
      // Also runs when Shopify replaces or re-adds this section in the editor.
      if (this.controller) return;
      this.reviews = Array.from(this.querySelectorAll('[data-review]'));
      if (!this.reviews.length) return;
      this.photos = Array.from(this.querySelectorAll('[data-photo]'));
      this.status = this.querySelector('[data-status]');
      this.pauseButton = this.querySelector('[data-pause]');
      this.index = 0;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (Date.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); return; }
        if (button.hasAttribute('data-prev')) this.go(this.index - 1, true);
        if (button.hasAttribute('data-next')) this.go(this.index + 1, true);
        if (button.hasAttribute('data-photo')) this.go(Number(button.dataset.index), true);
        if (button.hasAttribute('data-pause')) {
          this.paused = !this.paused;
          this.updatePause();
          this.schedule();
        }
      }, options);
      this.addEventListener('keydown', (event) => {
        // In RTL, ArrowLeft moves to the next review and ArrowRight moves back.
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        if (event.target.closest('input,textarea,select,[contenteditable="true"]')) return;
        event.preventDefault();
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.reviews.length - 1 : this.index + (event.key === 'ArrowLeft' ? 1 : -1);
        this.go(target, true);
      }, options);
      const stage = this.querySelector('.kr__stage');
      stage.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.target.closest('.kr__arrow')) return;
        this.startPoint = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, options);
      stage.addEventListener('pointerup', (event) => {
        const point = this.startPoint;
        this.startPoint = null;
        if (!point || point.id !== event.pointerId) return;
        const dx = event.clientX - point.x, dy = event.clientY - point.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.suppressClickUntil = Date.now() + 400;
          this.go(this.index + (dx > 0 ? 1 : -1), true);
        }
      }, options);
      stage.addEventListener('pointercancel', () => { this.startPoint = null; }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', (event) => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.updatePause(); this.schedule();
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const target = this.reviews.findIndex(review => review.dataset.blockId === String(event.detail.blockId));
        if (target >= 0) this.go(target);
      }, options);
      this.setAttribute('data-ready', '');
      this.updatePause();
      this.go(0);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
      this.controller = null;
      this.removeAttribute('data-ready');
    }
    go(index, announce = false) {
      const length = this.reviews.length;
      this.index = ((index % length) + length) % length;
      this.reviews.forEach((review, i) => { review.hidden = i !== this.index; });
      const focusedPhoto = this.photos.includes(document.activeElement) ? document.activeElement : null;
      this.photos.forEach((photo, i) => {
        const slot = (i - this.index + length) % length;
        photo.dataset.slot = String(slot);
        photo.hidden = slot >= Math.min(3, length);
        photo.setAttribute('aria-pressed', String(slot === 0));
        if (slot < 3) {
          const img = photo.querySelector('img');
          if (img) img.loading = 'eager';
        }
      });
      if (focusedPhoto && focusedPhoto.hidden) this.photos[this.index].focus({ preventScroll: true });
      if (announce && this.status) {
        this.status.textContent = `ביקורת ${this.index + 1} מתוך ${length}. ${this.reviews[this.index].innerText}`;
      }
      this.schedule();
    }
    updatePause() {
      if (this.pauseButton) this.pauseButton.textContent = this.paused ? 'הפעלת מעבר אוטומטי' : 'השהיית מעבר אוטומטי';
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.reviews.length < 2 || this.paused || this.hovered || this.focused || document.hidden || window.Shopify?.designMode) return;
      const interval = Math.max(4000, Number(this.dataset.interval) || 7000);
      this.timer = setTimeout(() => this.go(this.index + 1), interval);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
